import XIcon from '../components/XIcon.vue'

export const socialLinks = [
	{
		id: 1,
		name: 'GitHub',
		icon: 'github',
		url: 'https://github.com/SianLauwers',
	},
	{
		id: 2,
		name: 'X',
		customIcon: XIcon,
		url: 'https://x.com/sian_lauwers',
		isCustomIcon: true
	},
	{
		id: 3,
		name: 'LinkedIn',
		icon: 'linkedin',
		url: 'https://www.linkedin.com/in/sian-lauwers-a66933226/',
	},
];
